var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Main'),_c('About'),_c('Steps'),_c('Accordion'),_c('Blockchain'),_c('Swiper'),_c('Bottom'),_c('Footer'),_c('PopUp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }